import React from 'react';

import Thumb from '../img/blogs/some-most-used-javascript-string-number-array-and-object.jpg';

const SomeMostUsedJavaScriptStringNumberArrayAndObject = {
    id: 2, permalink: "some-most-used-javascript-string-number-array-and-object", thumb: Thumb, postBy: "Wasek Bellah", postDate: "Apr 27, 2020", categories: "JavaScript", title: "Some most used JavaScript String, Number, Array and Object", shortDesc: "JavaScript is an object-oriented, dynamic programming language. Netscape engineer Brendan Eich created JavaScript in 1995.", fullDesc: <>
        <h2>1. string.charAt()</h2>
        <p>The <code>charAt()</code> method returns the character at the specified index in a string.</p>

        <h4>Syntax: <code>string.charAt(index)</code></h4>
        <pre className="code">
            const sentence = "Hello World, I am Wasek Bellah. Currently I am learning JavaScript"; <br />
            console.log("The character of the sentence at index 18 is: '" + sentence.charAt(18) + "'");
        </pre>
        <p><strong>Expected output:</strong> <code class="output">The character of the sentence at index 18 is: 'W'</code></p>

        <p><em>The index of the last character in a string is <strong>string.length - 1</strong>, the second last character is <strong>string.length - 2</strong>, and so on</em>:</p>
        <pre className="code">
            const sentence = "Hello World, I am Wasek Bellah. Currently I am learning JavaScript"; <br />
            console.log("The character of the sentence at index 10 from last is: '" + sentence.charAt(sentence.length - 10) + "'");
        </pre>
        <p><strong>Expected output:</strong> <code class="output">The character of the sentence at index 10 from last is: 'J'</code></p>


        <h2>2. string.includes()</h2>
        <p>The <code>includes()</code> method determines whether a string contains the characters of a specified string.</p>

        <p>This method returns <strong>true</strong> if the string contains the characters, and <strong>false</strong> if not.</p>

        <h4>Syntax: <code>string.includes(searchvalue)</code></h4>
        <pre className="code">
            const sentence = "Hello World, I am Wasek Bellah. Currently I am learning JavaScript"; <br />
            console.log("'sentence' constant contains 'Wasek'. " + sentence.includes("Wasek"));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">'sentence' constant contains 'Wasek'. true</code></p>

        <p><strong>1 more thing:</strong> The <code>includes()</code> method is <strong>case sensitive</strong>.</p>

        <pre className="code">
            const sentence = "Hello World, I am Wasek Bellah. Currently I am learning JavaScript"; <br />
            console.log("'sentence' constant contains 'wasek'. " + sentence.includes("wasek"));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">'sentence' constant contains 'wasek'. false</code></p>


        <h2>3. Number.parseFloat()</h2>
        <p>The <code>Number.parseFloat()</code> method parses an argument and returns a floating point number. If a number cannot be parsed from the argument, it returns <strong>NaN</strong>.</p>

        <h4>Syntax: <code>Number.parseFloat(value)</code></h4>
        <pre className="code">
            console.log(Number.parseFloat('345.6746Wasek'));
            </pre>
        <p><strong>Expected output:</strong> <code class="output">345.674</code></p>

        <pre className="code">
            console.log(Number.parseFloat('Wasek'));
            </pre>
        <p><strong>Expected output:</strong> <code class="output">NaN</code></p>


        <h2>4. array.every()</h2>
        <p>The <code>every()</code> method checks if all elements in an array pass a test (provided as a function).</p>

        <h4>Syntax: <code>array.every(function(currentValue, index, arr), thisValue)</code></h4>
        <pre className="code">
            const ages = [32, 33, 16, 40]; <br />
            console.log("'ages' array's every element are greater than or equal to 18. " + ages.every(age => (age >= 18)));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">'ages' array's every element are greater than or equal to 18. false</code></p>

        <p>The <code>every()</code> method executes the function once for each element present in the array.</p>

        <p>If it finds an array element where the <strong>function returns a false</strong> value, <code>every()</code> returns <strong>false</strong> (and does not check the remaining values)</p>

        <p>If no false occur, <code>every()</code> returns <strong>true</strong></p>


        <h2>5. array.join()</h2>
        <p>The <code>join()</code> method returns the array as a string.</p>

        <h4>Syntax: <code>array.join(separator)</code></h4>
        <pre className="code">
            const fruits = ["Banana", "Orange", "Apple", "Mango"]; <br />
            console.log(fruits.join(", "));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">Banana, Orange, Apple, Mango</code></p>

        <p>The elements will be separated by a specified separator. The default separator is <strong>comma (,)</strong>.</p>

        <p><strong>Note:</strong> this method will not change the original array.</p>


        <h2>6. array.sort()</h2>
        <p>The <code>sort()</code> method sorts the items of an array.</p>
        <h4>Syntax: <code>array.sort(compareFunction)</code></h4>
        <pre className="code">
            const fruits = ["Banana", "Orange", "Apple", "Mango"]; <br />
            console.log(fruits.sort());
        </pre>
        <p><strong>Expected output:</strong> <code class="output">[ 'Apple', 'Banana', 'Mango', 'Orange' ]</code></p>

        <p>The sort order can be either <strong>alphabetic</strong> or <strong>numeric</strong>, and either <strong>ascending (up)</strong> or <strong>descending (down)</strong>.</p>

        <p>By default, the <code>sort()</code> method sorts the values as strings in alphabetical and ascending order.</p>

        <p><strong>Note:</strong> This method changes the original array.</p>

        <p><em>Sort an array <strong>alphabetically</strong>, and then reverse the order of the sorted items (<strong>descending</strong>)</em>:</p>
        <pre className="code">
            const fruits = ["Banana", "Orange", "Apple", "Mango"]; <br />
            console.log(fruits.sort().reverse());
        </pre>
        <p><strong>Expected output:</strong> <code class="output">[ 'Orange', 'Mango', 'Banana', 'Apple' ]</code></p>

        <p><em>Sort numbers in an array in <strong>ascending order</strong></em>:</p>
        <pre className="code">
            const points = [40, 100, 1, 5, 25, 10]; <br />
            console.log(points.sort((a, b) => a - b));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">[ 1, 5, 10, 25, 40, 100 ]</code></p>

        <p><em>Sort numbers in an array in <strong>descending order</strong></em>:</p>
        <pre className="code">
            const points = [40, 100, 1, 5, 25, 10]; <br />
            console.log(points.sort((a, b) => b - a));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">[ 100, 40, 25, 10, 5, 1 ]</code></p>


        <h2>7. Object.freeze()</h2>
        <p>The <code>Object.freeze()</code> method freezes an object. A frozen object can no longer be changed.</p>

        <h4>Syntax: <code>Object.freeze(obj)</code></h4>
        <pre className="code">
            const fruits = mySelf = &#123;name: "Wasek Bellah"&#125;; <br />
            Object.freeze(mySelf); <br />
            mySelf.name = "Name Change"; <br />
            console.log(mySelf.name);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">Wasek Bellah</code></p>

        <p>Nothing can be <strong>added to or removed</strong> from the properties set of a <strong>frozen object</strong>.</p>

        <p><strong>Note:</strong> <code>freeze()</code> returns the same object that was passed into the function. It does not create a <strong>frozen copy</strong>.</p>


        <h2>8. Math.abs()</h2>
        <p>The <code>abs()</code> method returns the absolute value of a number.</p>

        <h4>Syntax: <code>Math.abs(x)</code></h4>
        <pre className="code">
            console.log(Math.abs(-8.125));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">8.125</code></p>

        <p><em>If the parameter is not a <strong>number, NaN</strong> is returned</em>:</p>
        <pre className="code">
            console.log(Math.abs("String"));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">NaN</code></p>

        <p><em>If the parameter is <strong>0, null</strong> is returned</em>:</p>
        <pre className="code">
            console.log(Math.abs(null));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">0</code></p>


        <h2>9. Math.log()</h2>
        <p>The <code>log()</code> method returns the natural logarithm (base E) of a number.</p>

        <h4>Syntax: <code>Math.log(x)</code></h4>
        <pre className="code">
            console.log(Math.log(5));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">1.6094379124341003</code></p>

        <p><em>If the parameter is <strong>negative, NaN</strong> is returned</em>:</p>
        <pre className="code">
            console.log(Math.log(-5));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">NaN</code></p>

        <p><em>If the parameter is <strong>0, -Infinity</strong> is returned</em>:</p>
        <pre className="code">
            console.log(Math.log(0));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">-Infinity</code></p>


        <h2>10. Math.sqrt()</h2>
        <p>The <code>sqrt()</code> method returns the square root of a number.</p>

        <h4>Syntax: <code>Math.sqrt(x)</code></h4>
        <pre className="code">
            console.log(Math.sqrt(81));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">9</code></p>

        <p><em>If value is a negative <strong>number, NaN</strong> is returned</em>:</p>
        <pre className="code">
            console.log(Math.sqrt(-81));
        </pre>
        <p><strong>Expected output:</strong> <code class="output">NaN</code></p>
    </>
}
export default SomeMostUsedJavaScriptStringNumberArrayAndObject;